import { ActiveInactive, EmployerStaffRole, SignUpMethod } from 'src/api';
import { SelectFieldOption } from 'src/types/components';

export const REQUEST_AUTO_APPROVE_OPTIONS = [
  {
    value: ActiveInactive.Active,
    label: 'Verifications will be approved automatically',
  },
  {
    value: ActiveInactive.Inactive,
    label: 'Verification requests will require your approval from your Clear Verify account',
  },
] as const satisfies SelectFieldOption[];

export const SIGN_UP_METHOD_OPTIONS = [
  {
    value: SignUpMethod.Ssn,
    label:
      'Allow employees to sign up without pin, using only their Social Security Number as verification',
  },
  {
    value: SignUpMethod.Pin,
    label: 'Require employees to use a pin to sign-up for their account',
  },
] as const satisfies SelectFieldOption[];

export const EMPLOYER_ROLE_OPTIONS = [
  {
    value: EmployerStaffRole.EmployerAdmin,
    label: 'Admin',
  },
  {
    value: EmployerStaffRole.EmployerManager,
    label: 'Manager',
  },
] as const satisfies SelectFieldOption[];
